"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldHistory = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const formatWhen = (d) => new Date(d).toLocaleString(undefined, { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
/**
 * Small 🕘 button beside a field that pops up its last few earlier values, each restorable.
 * Renders nothing when there is no history.
 */
function FieldHistory({ entries, onRestore, format, label, limit = 3 }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [restoringIndex, setRestoringIndex] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    const rootRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (!open)
            return;
        const onDocClick = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target))
                setOpen(false);
        };
        const onKey = (e) => {
            if (e.key === 'Escape')
                setOpen(false);
        };
        document.addEventListener('mousedown', onDocClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDocClick);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);
    const shown = entries.slice(0, limit);
    if (shown.length === 0)
        return null;
    const restore = async (value, index) => {
        if (!onRestore)
            return;
        setRestoringIndex(index);
        setError(null);
        try {
            await onRestore(value);
            setOpen(false);
        }
        catch (err) {
            setError(err instanceof Error && err.message ? err.message : 'Restore failed');
        }
        finally {
            setRestoringIndex(null);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("span", { ref: rootRef, style: { position: 'relative', display: 'inline-block', verticalAlign: 'middle' }, children: [(0, jsx_runtime_1.jsxs)("button", { type: "button", "aria-label": label ? `${label} history` : 'Change history', "aria-expanded": open, title: "Earlier values", onClick: (e) => {
                    e.stopPropagation();
                    setOpen((o) => !o);
                }, style: {
                    background: 'none',
                    border: 'none',
                    padding: '4px 6px',
                    minHeight: 28,
                    cursor: 'pointer',
                    fontSize: 12,
                    color: '#6b7280',
                    lineHeight: 1,
                }, children: ["\uD83D\uDD58 ", shown.length] }), open && ((0, jsx_runtime_1.jsxs)("span", { role: "dialog", "aria-label": label ? `${label} earlier values` : 'Earlier values', onClick: (e) => e.stopPropagation(), style: {
                    position: 'absolute',
                    zIndex: 50,
                    top: '100%',
                    left: 0,
                    marginTop: 4,
                    width: 260,
                    maxWidth: 'calc(100vw - 32px)',
                    background: '#fff',
                    color: '#111',
                    border: '1px solid #e5e7eb',
                    borderRadius: 8,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                    padding: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                    fontSize: 13,
                    fontWeight: 400,
                    textTransform: 'none',
                    letterSpacing: 'normal',
                }, children: [(0, jsx_runtime_1.jsx)("span", { style: { fontSize: 11, color: '#6b7280', fontWeight: 600 }, children: "Earlier values" }), shown.map((entry, i) => ((0, jsx_runtime_1.jsxs)("span", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, paddingTop: i ? 6 : 0, borderTop: i ? '1px solid #f3f4f6' : 'none' }, children: [(0, jsx_runtime_1.jsxs)("span", { style: { minWidth: 0 }, children: [(0, jsx_runtime_1.jsx)("span", { style: { display: 'block', wordBreak: 'break-word' }, children: entry.previousValue === null || entry.previousValue === '' ? ((0, jsx_runtime_1.jsx)("em", { style: { color: '#9ca3af' }, children: "(empty)" })) : format ? (format(entry.previousValue)) : (entry.previousValue) }), (0, jsx_runtime_1.jsxs)("span", { style: { display: 'block', fontSize: 11, color: '#9ca3af' }, children: ["until ", formatWhen(entry.changedAt), entry.by ? ` · ${entry.by}` : ''] })] }), onRestore && ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: () => restore(entry.previousValue, i), disabled: restoringIndex !== null, style: {
                                    flexShrink: 0,
                                    padding: '6px 10px',
                                    minHeight: 32,
                                    fontSize: 12,
                                    fontWeight: 600,
                                    color: '#4f46e5',
                                    background: '#eef2ff',
                                    border: 'none',
                                    borderRadius: 6,
                                    cursor: restoringIndex !== null ? 'wait' : 'pointer',
                                }, children: restoringIndex === i ? '…' : '↩ Restore' }))] }, i))), error && ((0, jsx_runtime_1.jsx)("span", { role: "alert", style: { fontSize: 12, color: '#dc2626' }, children: error }))] }))] }));
}
exports.FieldHistory = FieldHistory;
exports.default = FieldHistory;
